import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {isPlatformServer} from '@angular/common';
import {AuthService} from "common-domain";
import {PATH_CONSTANTS} from "../app-routing.module";
import {USER_PATH_CONSTANTS} from "../user/user-routing.module";

@Injectable({
  providedIn: 'root'
})
export class HomeComponentAuthGuard  {

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
              private authService: AuthService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (isPlatformServer(this.platformId)) {
      console.log("platform server")
      return true;
    }

    return this.checkLogin();
  }

  private checkLogin(): boolean {
    if (this.authService.isLoggedIn()) {
      // we should maybe use UrlTree object instead here
      setTimeout(() => this.router.navigateByUrl(PATH_CONSTANTS.USER + PATH_CONSTANTS.SLASH + USER_PATH_CONSTANTS.USER_HOME));
      return false;
    } else {
      return true;
    }
  }
}
